import { Component, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { ErrorService } from '../../services/error/error.service';
import { FileService } from '../../services/file.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { EnvironmentService } from '../../services/environment.service';
import { RegepOrderProcessService } from '../services/regep-order-process.service';
import { PersonalDataFormComponent } from 'src/app/+grid-application-shared/components/personal-data-form/personal-data-form.component';
import { RegepApplicationService } from '../services/regep-application.service';
import { RegepProcessStatus } from '../entities/enums/regepProcessStatus';
import { RegistrationOfEnergyProducerApplication } from '../entities/regep-application';
import { RegepCommentsService } from '../services/regep-comments.service';
import { CommunicationService } from '../../services/communication.service';

@Component({
  selector: 'app-personal-data-form',
  templateUrl: '../../+grid-application-shared/components/personal-data-form/personal-data-form.component.html',
  styleUrls: ['./regep-personal-data-form.component.scss'],
})
export class RegepPersonalDataFormComponent extends PersonalDataFormComponent<RegistrationOfEnergyProducerApplication> {
  constructor(
    commonService: CommonService,
    router: Router,
    route: ActivatedRoute,
    regepApplicationService: RegepApplicationService,
    regepCommentService: RegepCommentsService,
    errorService: ErrorService,
    fileService: FileService,
    localStorageService: LocalStorageService,
    cdRef: ChangeDetectorRef,
    environmentService: EnvironmentService,
    communicationService: CommunicationService,
    zone: NgZone,
    private orderProcessService: RegepOrderProcessService
  ) {
    super(
      commonService,
      router,
      route,
      regepApplicationService,
      regepCommentService,
      errorService,
      fileService,
      localStorageService,
      cdRef,
      environmentService,
      communicationService,
      zone
    );

    this.applicationTypeText = 'installation-data.reg-ep';
  }

  protected loadOrderProcess(): void {
    this.preventLeak(this.orderProcessService.orderProcess$).subscribe(orderProcess =>
      this.setEditabilityBasedOnProcessStatus(orderProcess.status)
    );

    this.orderProcessService.loadOrderProcess(this.application_id);
  }

  private setEditabilityBasedOnProcessStatus(status: RegepProcessStatus): void {
    const technicianRoleEditableStatuses = [RegepProcessStatus.EngineeringOpenIssue];
    const customerRoleEditableStatuses = [
      RegepProcessStatus.RegulationsOpenIssue,
      RegepProcessStatus.EngineeringOk,
      RegepProcessStatus.EngineeringOpenIssue,
    ];
    const internalRoleEditableStatuses = [
      RegepProcessStatus.EngineeringRequestUpdated,
      RegepProcessStatus.RequestSent,
      RegepProcessStatus.RegulationsRequestUpdated,
      RegepProcessStatus.CustomerDataAdded,
    ];

    this.editabilityBasedOnProcessStatus.technicianRole = technicianRoleEditableStatuses.includes(status);
    this.editabilityBasedOnProcessStatus.customerRole = customerRoleEditableStatuses.includes(status);
    this.editabilityBasedOnProcessStatus.internalRoles = internalRoleEditableStatuses.includes(status);
  }
}
